import { TriggerType, WEBHOOK_ADDITIONAL_TRIGGERS } from '@business/entities/webhook';
import { R } from '@core/utils/r';

export function getTitle(type: TriggerType): string {
  switch (type) {
    case TriggerType.contact || TriggerType.organization || TriggerType.deal:
      return R.upperFirst(type);
    case TriggerType.contactOrg:
      return 'Contact/Organization';
    case TriggerType.automations:
      return 'Automations';
  }

  return R.upperFirst(type);
}

export function getAdditionalTriggerTitle(trigger: string): string {
  switch (trigger) {
    case WEBHOOK_ADDITIONAL_TRIGGERS.TICKET_MESSAGE:
      return 'Support Ticket Messages';
    default:
      return R.upperFirst(trigger.replace('.', ' '));
  }
}

export function getAdditionalTriggerDescription(trigger: string): string {
  switch (trigger) {
    case WEBHOOK_ADDITIONAL_TRIGGERS.TICKET_MESSAGE:
      return 'Fires when a client replies to a ticket or adds a comment to a task';
    default:
      return '';
  }
}
